import axiosInstance from "../axios-instance";
import { CurrentUser, TermsAgreementType } from "./types";

const FIRST_LOGIN_STATUSES = [404, 403];

export const getCurrentUser = async () => {
  try {
    const response = await axiosInstance.get<CurrentUser>(
      "/v1/users/current-user",
    );
    return {
      status: response.status,
      data: response.data,
      isFirstLogin: false,
    };
  } catch (error: any) {
    const status = error.response?.status;
    const isFirstLogin = FIRST_LOGIN_STATUSES.includes(status);
    return {
      status: status || 500,
      data: isFirstLogin
        ? error.response.data || null
        : error.response?.data || error.message || "Unknown error",
      isFirstLogin,
    };
  }
};

export const postUser = async (agreements: TermsAgreementType[]) => {
  const response = await axiosInstance.post("/v1/users", { agreements });
  return response;
};

export const postTermsAgreements = async (
  agreements: TermsAgreementType[],
) => {
  const response = await axiosInstance.post("/v1/users/terms-agreements", {
    agreements,
  });
  return response;
};

export const postUserNames = async (
  emails: string[],
): Promise<Record<string, string | null>> => {
  const response = await axiosInstance.post("/v1/users/names", { emails });
  return response.data.names ?? {};
};
